export default function shouldUseBuyShipping(fulfillmentOrder, form) {
	if (fulfillmentOrder.deliveryReplacement == true) {
		form.$('useBuyShipping').value = false;
	} else if (fulfillmentOrder.order.isPrime && fulfillmentOrder.order.channel.useBuyShippingForPrime) {
		form.$('useBuyShipping').value = true;
		return true;
	} else if (!fulfillmentOrder.order.isPrime && fulfillmentOrder.order.channel.useBuyShippingForNonPrime) {
		form.$('useBuyShipping').value = true;
		return true;
	} else if (fulfillmentOrder.order.channel.useAmazonBuyShipping) {
		form.$('useBuyShipping').value = true;
		return true;
	} else {
		form.$('useBuyShipping').value = false;
		return false;
	}
}
